// StripeContext.js
import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const StripeContext = createContext();

export const useStripe = () => {
  return useContext(StripeContext);
};

export const StripeProvider = ({ children }) => {
  const stripePromise = loadStripe('pk_test_51O7BhNBifWZsPLEzMJMHiIOmz0ffZvE5bBUNVDeV3UffKYrleTOqwGtNJPBCT8ZnLjBse6xN4WkXKR6gedfpDPLU00SkDRS9y1');

  return (
    <StripeContext.Provider value={stripePromise}>
      <Elements stripe={stripePromise}>{children}</Elements>
    </StripeContext.Provider>
  );
};
